const prefix = "/";

export default [
  {
    path: prefix + "index.html",
    meta: { auth: true, public: false },
    title: "HomeView",
    name: "HomeView",
    component: () => import(`../views/dashboard/Index.vue`),
  },
  {
    path: prefix,
    meta: { auth: true, public: false },
    title: "HomeViewAlias",
    name: "HomeViewAlias",
    component: () => import(`../views/dashboard/Index.vue`),
  },
  {
    path: `${prefix}dashboard`,
    meta: { auth: true, public: false },
    title: "Dashboard",
    name: "Dashboard",
    component: () => import(`../views/dashboard/Index.vue`),
  },
  {
    path: "/perfil",
    meta: { auth: true, public: false },
    title: "Perfil",
    name: "Profile",
    component: () => import(`@/views/user/Profile.vue`),
  },
  {
    path: "/configuracoes-do-sistema",
    meta: { auth: true, public: false },
    title: "Tela de Configurações",
    name: "Configurations",
    component: () => import(`@/views/configurations/Configurations.vue`),
  },
];
